export const ISetConfigurationServerURLUseCaseType = Symbol('ISetConfigurationServerURLUseCase');
